import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ApiAnalyticsService } from 'src/app/services/api-analytics.service';
import { ApiService } from '../../services/api.service';
import { DataService } from "../../services/data.service";
import { NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { DeviceInfoService } from '../../utils/device-info.service';
import { URL_IMG, URL_EXT } from '../../constants/general';
import { CustomValidators } from '../../utils/validators';

@Component({
  selector: 'app-additional-data',
  templateUrl: './additional-data.component.html',
  styleUrls: ['./additional-data.component.scss'],
  providers: [NgbPopoverConfig],
  host:{
    'class':'col forms-confirmation-style d-flex justify-content-center first-aditional-content'
  }
})
export class AdditionalDataComponent implements OnInit {

  form: UntypedFormGroup;
  occupations:any[]=[];
  occupationsRadio:any[]=[];
  occupationsSelect:any[]=[];
  civilStatusList:any[]=[];
  dataOccupation = {
    radio_occupation:'',
    select_occupation:'',
    cx_ocupacion:'',
    cx_ocupacion_id:'',
    cx_profesion:'',
    nombreEmpresa:'',
    puesto: '',
    cx_edo_civil_id: '',
    cx_edo_civil: '',
    cx_curp:'',
    cx_rfc_tin:'',
    conBeneficiarios:''
  }
  showInputOccupation:boolean=true;
  isMobile:boolean=false;
  url=URL_EXT;
  url_img = URL_IMG;
  msgErrorCURP:string='';
  msgErrorRFC:string='';
  tittleRFC='RFC';

  constructor(private formBuilder:UntypedFormBuilder, 
              private spinner: NgxSpinnerService,
              private router: Router,
              private api: ApiService,
              private data: DataService,
              private apiAnalytics :ApiAnalyticsService,
              private device: DeviceInfoService,
              private popover: NgbPopoverConfig) 
  { 
    this.setConfig();
    this.validateSession();
    this.getOccupations();
    this.buildForm();
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.data.setStep('opciones/autonomo-completa-informacion');
  }

  setConfig() {
    this.isMobile = this.device.getIsMobile();
    if(this.isMobile){
      this.popover.placement = 'auto';
      this.popover.triggers = 'click';
    } else {
      this.popover.placement = 'auto';
      this.popover.triggers = 'click';
    }    
  }

  validateSession() {    
    if( sessionStorage.getItem('data_occupation') ) {
      this.dataOccupation = JSON.parse( sessionStorage.getItem('data_occupation') ); 
      this.validateShowInputs();
      console.log(this.dataOccupation);
    }
  }

  validateShowInputs() {
    if(this.dataOccupation.radio_occupation == '01' || this.dataOccupation.radio_occupation == '05') {
      this.showInputOccupation = true;
    } else if(this.dataOccupation.radio_occupation == "0") {
      this.showInputOccupation = false;      
    } else {
      this.showInputOccupation = false;
    }
  }

  previous(type) {
    console.log(`Autonomo | Paso2 | ${type}Regresar`);
    this.apiAnalytics.gTag(`Autonomo | Paso2 | ${type}Regresar`, 'Autonomo | Paso2', 'Tres Pasos Bursanet','1');
    if(sessionStorage.getItem('data_identification')) {
      const dataIdentificacion = JSON.parse( sessionStorage.getItem('data_identification') );
      if(dataIdentificacion.proof_address == '0') {
        this.router.navigate(['/opciones/autonomo-comprobante']);
      } else if(dataIdentificacion.proof_address == '1') {
        this.router.navigate(['/opciones/autonomo-identificacion']);       
      }
    } else {
      this.router.navigate(['/opciones/autonomo-identificacion']);
    }    
  }

  getOccupations() {
    this.spinner.show();
    this.api.getOccupations().subscribe((data: any[]) => {
      this.spinner.hide();
      if(data == undefined) {
        this.radioOccupation.setValue('0');
        this.setRequiredOptions();
      } else {
        if(data.length > 0) {
          this.occupations = data;
          this.reOrderOccupations();
        } else {
          this.radioOccupation.setValue('0');
          this.setRequiredOptions();
        }
      }
      this.getCivilStatus();
    }, error => {
      this.spinner.hide();
      this.radioOccupation.setValue('0');
      this.setRequiredOptions();
      console.log('Error: ', error);
    });
  }

  getCivilStatus() {
    this.spinner.show();
    this.api.getCivilStatus().subscribe((data: any[]) => {
      this.spinner.hide();
      this.civilStatusList = data;

      this.civilStatusList.sort((b, a) => {
        if(a.bez20 > b.bez20) return 1;
        if(a.bez20 < b.bez20) return -1;    
        return 0;
      });

    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

  reOrderOccupations() {
    let countRadio=0;
    let countOption=0;
    Object.keys(this.occupations).map((key) => {
      if(this.occupations[key].xkbez != undefined && this.occupations[key].xlbez != undefined && this.occupations[key].ocupacion != undefined) {

        switch(this.occupations[key].xkbez.toLowerCase().trim()){
          case 'estudiante':
            this.occupationsRadio[countRadio]=this.occupations[key];
            this.occupationsRadio[countRadio].xlbez = 'Estudio';
            countRadio++;
          break;
          case 'empresario':
            this.occupationsRadio[countRadio]=this.occupations[key];
            this.occupationsRadio[countRadio].xlbez = 'Tengo un empresa';
            countRadio++;
          break;
          case 'empleado':
            this.occupationsRadio[countRadio]=this.occupations[key];
            this.occupationsRadio[countRadio].xlbez = 'Trabajo en una empresa';
            countRadio++;
          break;
          case 'ama de casa':
            this.occupationsRadio[countRadio]=this.occupations[key];
            this.occupationsRadio[countRadio].xlbez = 'Al hogar';
            countRadio++;
          break;
          default:
            this.occupationsSelect[countOption]=this.occupations[key];
            countOption++;
          break;
        }

      }
    });
    
    if(this.occupationsRadio.length == 0) {
      this.radioOccupation.setValue('0');
      this.setRequiredOptions();
    }
  }

  private buildForm() {
    let validatorsRFC;
    if(this.dataOccupation.radio_occupation == '01' || this.dataOccupation.radio_occupation == '05' || this.dataOccupation.radio_occupation == '') {
      validatorsRFC=[CustomValidators.rfcSinHomoclave];
    } else {
      validatorsRFC=[Validators.required, CustomValidators.rfcConHomoclave];
    }
    this.form = this.formBuilder.group({
      radio_occupation: [this.dataOccupation.radio_occupation, [Validators.required] ],
      select_occupation: [this.dataOccupation.select_occupation],
      cx_profesion: [this.dataOccupation.cx_profesion ],
      nombreEmpresa: [this.dataOccupation.nombreEmpresa ],
      puesto: [this.dataOccupation.puesto, ],
      cx_edo_civil: [this.dataOccupation.cx_edo_civil_id, [Validators.required] ],
      cx_rfc_tin: [this.dataOccupation.cx_rfc_tin, validatorsRFC],
      cx_curp: [this.dataOccupation.cx_curp, [Validators.required, Validators.pattern(/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/)]],
      conBeneficiarios: [this.dataOccupation.conBeneficiarios, [Validators.required] ]
    })
  }

  get radioOccupation() {
    return this.form.get('radio_occupation');
  }

  get selectOccupation() {
    return this.form.get('select_occupation');
  }

  get proffesionInput() {
    return this.form.get('cx_profesion');
  }

  get companyInput() {
    return this.form.get('nombreEmpresa');
  }

  get positionInput() {
    return this.form.get('puesto');
  }

  get civilStatusInput() {
    return this.form.get('cx_edo_civil');
  }

  get curpInput() {
    return this.form.get('cx_curp');
  }

  get rfcInput() {
    return this.form.get('cx_rfc_tin');
  }

  get beneficiarioInput() {
    return this.form.get('conBeneficiarios');
  }

  showErrorCURP():boolean {
    if(this.curpInput.invalid && this.curpInput.touched && this.curpInput.dirty) {
      if(this.curpInput.value == '') {
        this.msgErrorCURP='Dato requerido';
      } else {
        this.msgErrorCURP='El dato ingresado es inválido';        
      }
      return true;      
    } else {
      this.msgErrorCURP='';
      return false;
    }    
  }

  showErrorRFC():boolean {    
    if(this.rfcInput.hasError('required') && this.rfcInput.touched && this.rfcInput.dirty) {
      this.msgErrorRFC='Dato requerido';
      return true;
    } else if(this.rfcInput.hasError('rfc_invalid') && this.rfcInput.touched && this.rfcInput.dirty) {
      this.msgErrorRFC='El dato ingresado es inválido';
      return true;
    } else {
      return false;
    }     
  }

  setRequiredOptions() {    
    
    this.setValueOccupationRadio();
    switch(this.radioOccupation.value){
      case '01':
        this.selectOccupation.setValue('');  
        this.clearValidatorsInputs();         
        this.clearValidatorSelect();  
        this.tittleRFC='RFC sin homoclave';  
        break;
      case '05':
        this.selectOccupation.setValue('');
        this.clearValidatorsInputs();        
        this.clearValidatorSelect();   
        this.tittleRFC='RFC sin homoclave';     
        break;
      case "0":        
        this.clearValidatorsInputs();
        this.setValidatorSelect(); 
        this.tittleRFC='RFC';       
        break;
      default:
        this.selectOccupation.setValue('');
        this.setValidatorsInputs();        
        this.clearValidatorSelect();
        this.tittleRFC='RFC';   
        break;      
    } 
  }

  setValueOccupationRadio() {

    if(this.radioOccupation.value == '0') {
      this.dataOccupation.cx_ocupacion = '';
      this.dataOccupation.cx_ocupacion_id = '';
      this.dataOccupation.radio_occupation = '';
    } else {
      for (const item in this.occupations) {
        if(this.occupations[item].ocupacion == this.radioOccupation.value) {
          this.dataOccupation.cx_ocupacion_id = this.occupations[item].ocupacion;
          this.dataOccupation.cx_ocupacion = this.occupations[item].xkbez;
          this.dataOccupation.radio_occupation = this.radioOccupation.value;
        }
      }
    }  

    console.log(this.dataOccupation.cx_ocupacion_id+':'+this.dataOccupation.cx_ocupacion+':'+this.dataOccupation.radio_occupation);
  }

  setAnotherOption() {
    let select = this.selectOccupation.value;
    if(select != '') {
      this.radioOccupation.setValue("0");
      this.setValidatorsInputs();
    } else {
      this.tittleRFC='RFC'; 
      this.clearValidatorsInputs();
    }
    this.setValueOccupationSelect();
    this.selectOccupation.setValidators([Validators.required]);
    this.selectOccupation.updateValueAndValidity();
  }

  setValueOccupationSelect() {

    if(this.selectOccupation.value == '') {
      this.dataOccupation.cx_ocupacion = '';
      this.dataOccupation.cx_ocupacion_id = '';
      this.dataOccupation.select_occupation = '';
    } else {
      for (const item in this.occupations) {
        if(this.occupations[item].ocupacion == this.selectOccupation.value) {
          this.dataOccupation.cx_ocupacion_id = this.occupations[item].ocupacion;
          this.dataOccupation.cx_ocupacion = this.occupations[item].xkbez;
          this.dataOccupation.select_occupation = this.selectOccupation.value;
        }
      }
    }  

    console.log(this.dataOccupation.cx_ocupacion_id+':'+this.dataOccupation.cx_ocupacion+':'+this.dataOccupation.radio_occupation);
  }

  setValueCivilStatus() {
    for (const item in this.civilStatusList) {
      if(this.civilStatusList[item].marst == this.civilStatusInput.value) {
        this.dataOccupation.cx_edo_civil_id = this.civilStatusList[item].marst;
        this.dataOccupation.cx_edo_civil = this.civilStatusList[item].bez20;
      }
    }

    console.log('Estado Civil --->'+this.dataOccupation.cx_edo_civil_id+':'+this.dataOccupation.cx_edo_civil);
  }

  clearValidatorSelect() {
    this.selectOccupation.clearValidators();
    this.selectOccupation.updateValueAndValidity();
  }

  setValidatorSelect() {
    this.selectOccupation.setValidators([Validators.required]);
    this.selectOccupation.updateValueAndValidity();
  }

  clearValidatorsInputs() {
    this.showInputOccupation=true;

    this.proffesionInput.setValue('');
    this.proffesionInput.clearValidators();
    this.proffesionInput.updateValueAndValidity();

    this.companyInput.setValue('');
    this.companyInput.clearValidators();
    this.companyInput.updateValueAndValidity();

    this.positionInput.setValue('');
    this.positionInput.clearValidators();
    this.positionInput.updateValueAndValidity();

    this.rfcInput.setValidators([CustomValidators.rfcSinHomoclave]);
    this.rfcInput.updateValueAndValidity(); 
  }

  setValidatorsInputs() {
    this.showInputOccupation=false;
    this.proffesionInput.setValidators([Validators.required]);
    this.proffesionInput.updateValueAndValidity();

    this.companyInput.setValidators([Validators.required]);
    this.companyInput.updateValueAndValidity();

    this.positionInput.setValidators([Validators.required]);
    this.positionInput.updateValueAndValidity();

    this.rfcInput.setValidators([Validators.required, CustomValidators.rfcConHomoclave]);
    this.rfcInput.updateValueAndValidity();
  }

  saveStepTwo(event:Event) {

    event.preventDefault();
    this.form.markAllAsTouched();
    console.log(this.form.valid)
    if(this.form.valid) {

      let type = '';
      if(this.beneficiarioInput.value == 'SI') {
        type ='ConBeneficiario';
      } else if(this.beneficiarioInput.value == 'NO') {
        type ='SinBeneficiario';
      }
      
      console.log(` Autonomo | Paso2 | ${type} | Continuar`);
      this.apiAnalytics.gTag(` Autonomo | Paso2 | ${type} | Continuar`, 'Autonomo | Paso2', 'Tres Pasos Bursanet','1');
      
      this.dataOccupation.cx_profesion = this.proffesionInput.value;
      this.dataOccupation.nombreEmpresa = this.companyInput.value;
      this.dataOccupation.puesto = this.positionInput.value;
      this.dataOccupation.cx_curp = this.curpInput.value;
      this.dataOccupation.cx_rfc_tin = this.rfcInput.value;
      this.dataOccupation.conBeneficiarios = this.beneficiarioInput.value;

      if(this.beneficiarioInput.value == 'NO') {
        sessionStorage.removeItem('data_beneficiary');
      }
      sessionStorage.removeItem('data_occupation');
      sessionStorage.setItem('data_occupation', JSON.stringify(this.dataOccupation) );

      if(this.beneficiarioInput.value == 'SI') {
        this.router.navigate(['opciones/autonomo-beneficiario']);
      } else if(this.beneficiarioInput.value == 'NO') {
        this.router.navigate(['opciones/autonomo-confirmacion']);
      }

    }
  }

}
